module.exports = __webpack_public_path__ + "img/banner.cc55030.png";